<template>
  <div id="container">
    <div class="item-box-content box-content-title">
      <div class="title-font-style">
        <span>仓储备货表</span>
      </div>
    </div>
    <div>
      <el-form class="search-style" :model="queryParams">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="日期：" label-width="42px">
              <el-date-picker
                v-model="time"
                style="width:97%;"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                 :clearable='false'
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="仓库：" label-width="42px">
              <el-select v-model="valList[0].value" placeholder="请选择">
                <el-option
                  v-for="(item,index) in stockSelect"
                  :key="index"
                  :label="item.storageName"
                  :value="item.storageName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="部门：" label-width="42px">
              <el-select v-model="arr" multiple placeholder="请选择">
                <el-option
                  v-for="(item,index) in department"
                  :key="index"
                  :label="item.orgName"
                  :value="item.orgName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-show="showAll" style="margin-bottom:15px;">
            <el-form-item label="配货人：" label-width="60px">
              <el-input v-model="valList[2].value"></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="showAll? 24 : 6"
            style="text-align:right"
          >
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
            <el-button @click="exportOut">导出</el-button>
            <el-button type="text" style="margin-left:10px" @click="closeSearch">
              {{word}}
              <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height:tableHeight+'px'}">
        <el-table
        :summary-method="getSummaries"
           show-summary
          :max-height="tableHeight"
          border
          ref="tableRef"
          tooltip-effect="dark"
          :data="list"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="日期" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.processDate || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="备货仓库" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.storageName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="备货货架" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.shelvesName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="品牌" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.brandName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="客户名称" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.cusName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="系列" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.seriesName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="型号" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.proModel || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="订货号" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.proOrdernum || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="实际备货数量" show-overflow-tooltip width="150px">
            <template slot-scope="scope">
              <div class="line-limit-length">{{String(scope.row.lockCount) || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="采购总价" show-overflow-tooltip width="150px">
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.purchaseTotal |priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="合同编号"  show-overflow-tooltip width="100px">
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.contractCode || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="产品名称"  show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.proName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="配货人" width="100px">
            <template slot-scope="scope">
              <div>{{ scope.row.staffCnName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="所属部门" width="100px">
            <template slot-scope="scope">
              <div>{{ scope.row.orgName || '--'}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { isSuccess, downLoadFileBlob } from '@/util/tool'
import { getComAll } from '@/api/fiance/fianceManage' // 部门
import { queryStorageStock, exportStorageStock } from '@/api/data/data'

export default {
  components: {
    pagination
  },
  mounted() {
    this.gethouseList() // 获取仓库
    getComAll().then(res => {
      // 部门
      if (isSuccess(res)) {
        this.department =
          res.data.obj && res.data.obj.filter(item => item.orgFatherId !== 0)
      }
    })
    this.addDate()
  },
  data() {
    return {
      arr: [],
      showAll: false, // 是否展开全部
      stockSelect: [], // 仓库
      department: [], // 部门
      tableHeight: window.innerHeight - 385,
      queryParams: {},
      searchList: [],
      list: [],
      time: [],
      loadingTable: false, // 列表loading
      pageSize: 30, //
      currentPage: 1, // 页码
      total: 0, // 列表总数
      valList: [
        { value: '', column: 'storageName' },
        { value: '', column: 'orgName' },
        { value: '', column: 'staffCnName' }
      ],
      updateTime: '',
      yearsTime: ''
    }
  },
  computed: {
    word: function() {
      if (this.showAll === false) {
        // 对文字进行处理
        return '展开'
      } else {
        return '收起'
      }
    }
  },
  methods: {
    // 默认展示当月所有仓库、所有货架的所有备货状况
    addDate() {
      const nowDate = new Date()
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      }
      const newmonth = date.month < 10 ? '0' + date.month : date.month
      const newdate = date.date < 10 ? '0' + date.date : date.date
      this.updateTime = date.year + '-' + newmonth + '-' + newdate // 当前年月日
      this.yearsTime = date.year + '-' + newmonth + '-' + '01'
      this.time = [this.yearsTime, this.updateTime]
      this.onSearch()
    },
    // 获取仓库信息
    async gethouseList() {
      this.stockSelect = await this.$houseInformation()
    },
    closeSearch() {
      this.showAll = !this.showAll
    },
    // 总计
    getSummaries (param) { // 合计
      const sums = []
      param.columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
        } else if (index === 8) {
          sums[index] = param.data.reduce((tot, prov) => {
            return tot + +(prov.lockCount)
          }, 0)
        } else if (index === 9) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +(prov.purchaseTotal)
          }, 0)
          sums[index] = total.toFixed(2)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },

    getList(data) {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.searchList ? this.searchList : [],
        queryPageName: ''
      }
      queryStorageStock(this.currentPage, this.pageSize, params).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.obj.records
          this.total = res.data.obj.total
          this.loadingTable = false
        }
      })
    },
    // 查询
    onSearch() {
      this.searchList = []
      if (this.time.length === 2) {
        this.searchList.push({
          value: this.time[0],
          endValue: this.time[1],
          column: 'processDate'
        })
      }
      this.valList[1].value = this.arr.join(',')
      if (this.valList.some(ele => ele.value) || this.time.length === 2) {
        this.pageSize = 30
        this.currentPage = 1
        this.valList.forEach(ele => {
          if (ele.value) {
            ele.collection = true
            this.searchList.push(ele)
          }
        })
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    // 重置
    onReset() {
      this.pageSize = 30
      this.currentPage = 1
      this.valList.forEach(ele => {
        delete ele.value
      })
      this.arr = []
      this.searchList = []
      this.time = []
      this.showAll = false
      this.getList()
    },
    // 导出
    exportOut() {
      const params = {
        criteriaVoList: this.searchList,
        queryPageName: ''
      }
      exportStorageStock(params)
        .then((res) => {
          downLoadFileBlob(this, res)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
